import { Component } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ReportManagementService } from '../../services/report-management.service';
import { ReportRequest } from '../../models/report-request.model';
import { ValuationSettings } from '../../models/valuation-settings.model';
import { FutureValuesSettings } from '../../models/future-values-settings.model';
import { AgreementTermModification } from '../../models/agreement-term-modification.model';
import { AgreementEndMileageModification } from '../../models/agreement-end-mileage-modification.model';
import { SettingsService } from '../../../settings/services/settings.service';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import { Application } from '../../../settings/enums/application.enum';
import { RoutingService } from '../../../routing/services/routing.service';
import { ReportValuesSource } from 'app/report/enums/report-values-source';
import { Report } from 'app/report/models/report.model';
import { ReportDownloadService } from 'app/report/services/report-download.service';
import * as FileSaver from 'file-saver';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-report-new-component',
  templateUrl: './report-new.component.html',
  styleUrls: ['./report-new.component.scss']
})
export class ReportNewComponent {
  private chosenFiles: File[];
  private appSettings = this.settingsService.Get();
  private application: Application;
  private fileError: string;
  chosenFileName = '';

  get showCompareToDataset() {
    return this.reportType === Report.ReportTypes.movementReportType;
  }

  get showDataset() {
    return this.reportType !== Report.ReportTypes.idReportType;
  }

  get submitText() {
    if (this.isFleet || this.reportType === Report.ReportTypes.idReportType) {
      return 'Build Report';
    }
    return 'Continue';
  }

  get csvReportSelected() {
    return this.reportType === Report.ReportTypes.csvReportType;
  }

  get showSummaryOptions() {
    return this.reportOutputTypeSelection === 'Summary';
  }

  get showCompareAgainstOptions() {
    return !this.isFleet && (this.reportType === Report.ReportTypes.futureValuesReportType 
      || this.reportType === Report.ReportTypes.unsoldVehiclesReportType 
      || this.reportType === Report.ReportTypes.disposalReportType);
  }

  compareAgainstOptions() : Array<any> 
  {
    if(this.reportType == Report.ReportTypes.futureValuesReportType){
        return this.compareAgainstFields;
      }
      else {
        return this.compareAgainstFields.filter(f => f.id<=2);
      }
  }

  applicationTerminology: string;

  futureValues = false;
  futureValueSelection = 'ContractEnd';
  reportForm: FormGroup;
  report: ReportRequest;
  creatingReport = false;
  datasetDates;
  specificFutureDates = [];
  reportOutputTypeSelection = 'Full';
  compareAgainstField =  0;
  netOrGrossModifier = 0;
  modelLoaded: boolean;

  movementReportArguments = {
    compareDatasetDate: '',
    compareAgainstDatasetDate: '',
    reportValuesSource: ReportValuesSource.UsedValues
  };

  vehicleConditionTypes: any = [
    { id: null, name: 'Industry Standard' },
    { id: 1, name: 'Clean' },
    { id: 2, name: 'Average' },
    { id: 3, name: 'Below Average' },
    { id: 4, name: 'Retail' }
  ];

  compareAgainstFields: Array<any> = [
    {id:0, name:'Guaranteed Minimum Future Value'},
    {id:1, name:'Balance At Voluntary Termination Date'},
    {id:3, name:'Future Outstanding Balance'},
  ];

  private get compareAgainstValue() : number {
    if(this.compareAgainstField == 0)
      return 0;

    return this.compareAgainstField + this.netOrGrossModifier;
  }


  public myDatePickerOptions: IMyDpOptions;
  public dateToDisplay: any = {
    date: {
      year: moment().year(),
      month: moment().month() + 1,
      day: moment().date()
    }
  };
  public today = moment().format('DD/MM/YYYY');

  // TODO it'd be best to replace with auto-generated enum based on ApiReportType enum, so they don't go out of sync - using eg Typewriter
  reportTypes = Object.keys(Report.ReportTypes).map(k => Report.ReportTypes[k]);

  reportType = Report.ReportTypes.csvReportType;
  defaultCondition = this.vehicleConditionTypes[0];
  defaultDatasetDate: any;

  agreementTermTypes: any = [
    { id: 0, name: 'None' },
    { id: 1, name: 'Reduce' },
    { id: 2, name: 'Increase' },
    { id: 3, name: 'Set' }
  ];

  mileageValueTypes: any = [
    { id: 0, name: '\'000 Miles / Kms' },
    { id: 1, name: '%' }
  ];

  defaultTermType = this.agreementTermTypes[0].id;
  defaultMileageType = this.agreementTermTypes[0].id;
  defaultMileageValueType = this.mileageValueTypes[0].id;
  defaultOutputMonth;

  log(a: any) {
    console.log(a);
  }

  private get isFleet() {
    return this.application === Application.fleet;
  }

  constructor(
    private reportManagementService: ReportManagementService,
    private builder: FormBuilder,
    private routingService: RoutingService,
    private settingsService: SettingsService,
    private downloadService: ReportDownloadService,
    private reportService: ReportService, 
  ) {
    this.applicationTerminology = this.reportManagementService.applicationTerminology;
    this.application = this.reportManagementService.application;

    this.initaliseDatePicker();
    this.loadPage();

    reportManagementService.onDatasetsUpdated.subscribe(
      next => {
        this.datasetDates = next;
        this.defaultDatasetDate = next[0].date;
      },
      error => console.log(error)
    );

    this.reportService.getDatasetDates();
    this.populateFutureDates();
    this.defaultOutputMonth = this.specificFutureDates[0].id;
  }

  loadPage() {
    this.reportService.handleInitialPageDataLoad().then(() => {
      this.modelLoaded = true;
    })
  }


  getComparisonFieldLabel() : string {
    if(this.reportType.name=="Disposal")
      return "Disposal Value"

    if(this.reportType.name=="Unsold Vehicles")
      return "Unsold Vehicle Value"

    return this.reportType.name;
  }


  populateFutureDates = function() {
    let today = moment();
    this.specificFutureDates = [];
    for (let i = 1; i <= 60; i++) {
        today = today.add(1, 'month');
        const specificMonth = {
          label: today.format('MMMM YYYY'),
          id: i
        };
        this.specificFutureDates.push(specificMonth);
    }
  };

  shouldShowFieldError(formControl: FormControl) {
    if (!formControl) {
      return formControl.errors && (formControl.dirty || formControl.touched);
    }
  }

  private initaliseDatePicker() {
    const fiveYearsAgoToday = moment()
      .add(-5, 'years')
      .add(1, 'month')
      .add(-1, 'day') // allow the user to pick from a date exactly 5 years in the past or greater
      .hour(0)
      .minute(0)
      .second(0)
      .toDate();
    const fiveYearsFutureToday = moment()
      .add(5, 'years')
      .add(1, 'month')
      .add(1, 'day')
      .hour(0)
      .minute(0)
      .second(0)
      .toDate();

    this.myDatePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      disableUntil: {
        year: fiveYearsAgoToday.getFullYear(),
        month: fiveYearsAgoToday.getMonth(),
        day: fiveYearsAgoToday.getDate()
      },
      disableSince: {
        year: fiveYearsFutureToday.getFullYear(),
        month: fiveYearsFutureToday.getMonth(),
        day: fiveYearsFutureToday.getDate()
      },
      showClearDateBtn: false
    };
  }

  get todaysDateMin() {
    const today = moment();
    return today.add(-5, 'years').hour(0).minute(0).second(0); // return 5 years ago today at midnight
  }

  onClearReport(form: NgForm) {
    form.controls.title.reset();
    form.controls.addFutureValues.reset();
    form.controls.addUsedValues.reset();
    form.controls.files.reset();
    form.controls.agreementMileageToggle.reset();
    form.controls.agreementSettingsToggle.reset();
    this.futureValueSelection = 'ContractEnd';
    this.reportOutputTypeSelection = 'Full';
    this.chosenFileName = '';
    this.chosenFiles = [];
    this.defaultDatasetDate = this.datasetDates[0].date;
    this.defaultCondition = this.vehicleConditionTypes[0];
    this.defaultMileageType = this.agreementTermTypes[0].id;
    this.defaultTermType = this.agreementTermTypes[0].id;
    this.defaultMileageValueType = this.mileageValueTypes[0].id;
    this.dateToDisplay = {
      date: {
        year: moment().year(),
        month: moment().month() + 1,
        day: moment().date()
      }
    };
  }

  onCreateNewReport(form: NgForm) {
    if (form.valid) {
      this.creatingReport = true;
      const reportRequest = new ReportRequest();
      reportRequest.title = form.value.title;
      reportRequest.files = this.chosenFiles;
      reportRequest.reportTypeId = form.value.reportType.id;
      reportRequest.conditionType = form.value.vehicleCondition.id;
      reportRequest.vehicleConditionName = form.value.vehicleCondition.name;
      reportRequest.datasetDate = form.value.datasetDate;
      reportRequest.isDefaultDataset = reportRequest.datasetDate == this.datasetDates[0].date;
      reportRequest.reportTypeName =  form.value.reportType.name + ' ' + this.reportOutputTypeSelection;

      if(this.showCompareAgainstOptions) {
        reportRequest.compareAgainstFieldId = this.compareAgainstValue;
      }
      
      if (this.reportType === Report.ReportTypes.movementReportType) {
        reportRequest.compareToDatasetDates = [this.movementReportArguments.compareAgainstDatasetDate];
        reportRequest.reportValuesSource = this.movementReportArguments.reportValuesSource;
      }

      const todaysDate =
        this.dateToDisplay !== null
          ? new Date(
              this.dateToDisplay.date.year,
              this.dateToDisplay.date.month - 1,
              this.dateToDisplay.date.day,
              0,
              0,
              0
            )
          : moment().format('L'); // DD/MM/YYYY
      reportRequest.todaysDate = moment(todaysDate).format(
        'YYYY-MM-DDTHH:mm:ss'
      );

      const valSettings = new ValuationSettings();
      valSettings.addUsedValues = form.value.addUsedValues;
      valSettings.addFutureValues = form.value.addFutureValues;
      valSettings.addTermSettings = form.value.agreementSettingsToggle;
      valSettings.addMileageSettings = form.value.agreementMileageToggle;
      reportRequest.valuationSettings = valSettings;

      if (reportRequest.valuationSettings.addFutureValues) {
        const settings = new FutureValuesSettings();
        settings.outputAllMonths = this.futureValueSelection === 'All';
        settings.outputForSpecificMonth = this.futureValueSelection === 'Set';
        settings.specificMonthToOutput = settings.outputForSpecificMonth ? form.value.specificOutputMonth : 0;
        reportRequest.valuationSettings.futureValuationSettings = settings;
      }

      if (
        reportRequest.valuationSettings.addTermSettings ||
        reportRequest.valuationSettings.addMileageSettings
      ) {
        if (
          reportRequest.valuationSettings.futureValuationSettings === undefined
        ) {
          reportRequest.valuationSettings.futureValuationSettings = new FutureValuesSettings();
        }
        const termModification = new AgreementTermModification();
        termModification.termModificationType = form.value.agreementTermType;
        termModification.adjustByMonths = form.value.agreementTerm;

        let modificationType = 0;
        const changeType = form.value.mileageChangeType;
        const adjustType = form.value.mileageAdjustmentType;

        modificationType = this.getModificationTypeFromChangeAndAdjustTypes(
          changeType,
          adjustType
        );

        const endMileageModification = new AgreementEndMileageModification();
        endMileageModification.mileageModificationType = modificationType;

        if (adjustType === 0) {
          endMileageModification.adjustByValue =
            form.value.mileageAdjustment * 1000;
        } else {
          endMileageModification.adjustByValue = form.value.mileageAdjustment;
        }

        reportRequest.valuationSettings.futureValuationSettings.agreementTermModification = termModification;
        reportRequest.valuationSettings.futureValuationSettings.agreementEndMileageModification = endMileageModification;
      }

      this.reportManagementService.createNewReport(reportRequest);

      if (this.application === Application.fleet || this.reportType === Report.ReportTypes.idReportType) {
        this.routingService.routeToSaveProject();
      } else {
        this.routingService.routeToAddProjectAdjustments();
      }
    }
  }

  getModificationTypeFromChangeAndAdjustTypes(changeType: any, adjustType: any) {
      // There are only certain valid scenarios when it comes to Mileage Settings.
      // This is between the agreementTermTypes and mileageValueTypes above.

      // none (0) is set when type is 0 for either.
      // reduceByMileage (1) is a combination of 1,0.
      // reduceByPercent (2) if a combination of 1,1.
      // increaseByMileage (3) is a combination of 2,0.
      // increaseByPercent (4) if a combination of 2,1.
      // setToValue (5) is a combination of 3,0.

      // 3,1 is an invalid combination.
    if (changeType === 0) {
      return 0;
    } else if (changeType === 1 && adjustType === 0) {
      return 1;
    } else if (changeType === 1 && adjustType === 1) {
      return 2;
    } else if (changeType === 2 && adjustType === 0) {
      return 3;
    } else if (changeType === 2 && adjustType === 1) {
      return 4;
    } else if (changeType === 3 && adjustType === 0) {
      return 5;
    } else {
      return -1;
    }
  }

  fileChangeEvent(fileInfo: any) {

    if(fileInfo.target.files.length == 0){
    return ;
    }

    this.fileError = '';
    this.chosenFiles = null;
    this.chosenFileName = '';
    
    if (fileInfo.target.files.length > 0) {
      const chosenFileName: string = fileInfo.target.files[0].name;
      const extension = chosenFileName.split('.').reverse()[0];

      if (['csv', 'zip'].every(ext => extension.toUpperCase() !== ext.toUpperCase())) {
        this.fileError =
          'You have selected a file that is not a Csv or Zip, please select a valid input file.';
        return;
      }

      if (fileInfo.target.files[0].size===0){
        this.fileError =
        'You have selected a file that is empty, please select a valid input file.';
      return;
      }

      this.chosenFiles = fileInfo.target.files;
      this.chosenFileName = (<Array<File>>fileInfo.target.files)[0].name;
    }
  }

  downloadTemplate() {
    this.downloadService.downloadTemplate().subscribe(
      (response) => {
        FileSaver.saveAs(response.body, 'Template.csv');
      },
      (error) => console.error(error)
    );
  }
  
}


// WEBPACK FOOTER //
// ./src/app/report/components/create/report-new.component.ts